
export const INDIAN_RUPEE_SIGN = "₹";


// ------------------- Colors -------------------------
export const PRIMARY_COLOR = "text.primary";
export const SECONDARY_COLOR = "#6c8196";

export const RENTLY_TEXT_COLOR = "#002549";
export const RENTLY_R_ICON_COLOR = "#0067dd";
export const RENTLY_HOME_ICON_COLOR = "#ffc120";

// ------------------- Date Format -------------------------
export const DATE_FORMAT_STORAGE = "YYYY-MM-DD"; // ISO-like, good for databases
export const DATE_FORMAT_DISPLAY = "DD/MM/YYYY"; // Human-readable, common in EU

// ------------------- File Extension -------------------------
export const PDF_FORMAT = "pdf";
export const XLSX_FORMAT = "xlsx";
